/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Status_In_ExceptionInputs */

const en_inbound_status_in_exception = /** @type {(inputs: Inbound_Status_In_ExceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In exception`)
};

/**
* | output |
* | --- |
* | "In exception" |
*
* @param {Inbound_Status_In_ExceptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_status_in_exception = /** @type {((inputs?: Inbound_Status_In_ExceptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Status_In_ExceptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_status_in_exception(inputs)
});